<template>
  <div class="job-posting-auto-display" v-if="Object.keys(user).length > 0">
    <div class="form-group row">
      <div class="col-12">
        <div class="job-checkbox-wrapper">
          <input
            type="checkbox"
            class="job-checkbox-input"
            :class="{ 'locked-checkbox': scoutCheckBox }"
            id="jobPostingAutoDisplay"
            v-model="checkboxValue"
            @change="handleCheckboxChange($event)"
            :disabled="loading || !isAdmin"
          />
          <label 
            class="job-checkbox-label" 
            :class="{ 'locked-label': scoutCheckBox }"
            :for="scoutCheckBox ? null : 'jobPostingAutoDisplay'"
            :title="scoutCheckBox ? 'チェックを付けた後の解除はできません。求人表示を停止したい場合はBloomにご連絡ください。' : ''"
            @click="preventLabelClick"
          >
            自社の採用ホームページに掲載している求人を自動表示する
          </label>
        </div>
        <div class="mt-2 text-muted small">
          <div>チェックを付けた後の解除はできません。求人表示を停止したい場合はBloomにご連絡ください。</div>
          <div>なお、自社の求人に登録者がスカウト希望をした場合、希望日から2週間経過した時点で当該求人に対しては「スカウト希望期間終了」と自動表示されます。</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapGetters } from 'vuex';
export default {
  name: 'JobPostingAutoDisplay',
  computed: {
    ...mapGetters({
      user: 'getCurrentUser',
      isAdmin: 'currentUserIsAdmin'
    }),
    scoutCheckBox() {
      console.log(this.user);
      return this.user && this.user.scoutCheckBox;
    },
    checkboxValue: {
      get() {
        return this.scoutCheckBox;
      },
      set(value) {
        // If already checked, prevent unchecking
        if (this.scoutCheckBox && !value) {
          return; // Don't allow unchecking
        }
        // Only allow checking if not already checked
        if (!this.scoutCheckBox && value) {
          this.$store.dispatch('updateUserScoutCheckBox', value);
        }
      }
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    preventLabelClick(event) {
      if (this.scoutCheckBox) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    async handleCheckboxChange(event) {
      if (this.loading) return;
      
      const nextChecked = event && event.target ? !!event.target.checked : this.scoutCheckBox;
      
      // If trying to uncheck when already checked, prevent it
      if (this.scoutCheckBox && !nextChecked) {
        return; // The computed property already prevents this
      }
      
      this.loading = true;
      
      try {
        const payload = {
          scoutCheckBox: nextChecked
        };
        
        await ApiService.put(Api.endpoints.SCOUT_CHECK_UNCHECK, payload);
        
        console.log('Scout check status updated successfully');
        
      } catch (error) {
        console.error('Error updating scout check status:', error);
        
        // Revert the checkbox state on error
        this.$store.dispatch('updateUserScoutCheckBox', !nextChecked);
        
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.job-posting-auto-display {
  margin-top: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.job-posting-auto-display .form-group {
  margin-bottom: 0;
}

.job-checkbox-wrapper {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.job-checkbox-label {
  font-size: 14px;
  font-weight: normal;
  color: #333;
  cursor: pointer;
  margin-left: 8px;
  margin-bottom: 0;
}

.job-checkbox-input {
  height: 16px;
  width: 16px;
}

.job-checkbox-input:disabled + .job-checkbox-label {
  opacity: 0.6;
  cursor: not-allowed;
}

.job-checkbox-input:checked + .job-checkbox-label {
  font-weight: 500;
  opacity: 0.6;
}

.job-checkbox-input:checked {
  opacity: 0.6;
}

.locked-checkbox {
  cursor: not-allowed !important;
  pointer-events: none !important;
}

.locked-checkbox + .job-checkbox-label {
  cursor: not-allowed !important;
  opacity: 0.6;
}

.locked-label {
  cursor: not-allowed !important;
  position: relative;
}

.warning-icon {
  margin-left: 4px;
  font-size: 16px;
  display: inline-block;
  cursor: help;
  vertical-align: middle;
}

.locked-label:hover .warning-icon {
  animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}
</style>